import TrustlyLogo from '@assets/trustly/logo_white.svg?react'
import { TrustlyBanks } from '@components/TrustlyPane/TrustlyBanks'
import { getCountryAlpha2, tr, useDropDownMenu } from 'mmfintech-commons'

import './TrustlyPane.scss'
import cn from 'classnames'

type TrustlyPaneProps = {
  countryCode: string
}

export const TrustlyPane = ({ countryCode }: TrustlyPaneProps) => {
  const alpha2code = getCountryAlpha2(countryCode)

  const { visible, toggleDropDown, setRef } = useDropDownMenu()

  return (
    <div className='trustly-wrapper'>
      {/*<div className='recommended-text'>{tr('CHECKOUT.TRUSTLY.RECOMMENDED', 'Recommended')}</div>*/}

      <div className='heading-wrapper'>
        <div>
          <div className='heading'>{tr('CHECKOUT.TRUSTLY.HEADING', 'Bank payment')}</div>
          <div className='subheading'>
            {tr('CHECKOUT.TRUSTLY.SUBHEADING', 'Secure payment directly from your account.')}
          </div>
        </div>
        <div>
          <div className='logo-wrapper'>
            <TrustlyLogo />
          </div>
        </div>
      </div>

      <div className='trustly-benefits'>
        <div>
          <span>✓</span>
          {tr('CHECKOUT.TRUSTLY.BENEFITS_1', 'Pay from any bank account')}
        </div>
        <div>
          <span>✓</span>
          {tr('CHECKOUT.TRUSTLY.BENEFITS_2', 'Secure authentication with BankID')}
        </div>
        <div>
          <span>✓</span>
          {tr('CHECKOUT.TRUSTLY.BENEFITS_3', 'No forms or card details')}
        </div>
      </div>

      <TrustlyBanks alpha2CountryCode={alpha2code} />

      <div className='popup-container'>
        <div className='popup-button' onClick={toggleDropDown}>
          {tr('CHECKOUT.TRUSTLY.HOW_TRUSTLY_WORKS', 'How Trustly works')}
        </div>

        <div className={cn('popup-content', { visible })} ref={setRef}>
          <div>
            <b>{tr('CHECKOUT.TRUSTLY.POPUP.TITLE', 'Move money simply, quickly')}</b>
          </div>

          <div>{tr('CHECKOUT.TRUSTLY.POPUP.LINE_1', 'Secure deposit from your bank account')}</div>
          <div>
            &ndash;&nbsp;{tr('CHECKOUT.TRUSTLY.POPUP.LINE_2', 'Simply connect to your bank and move your money')}
          </div>
          <div>
            &ndash;&nbsp;{tr('CHECKOUT.TRUSTLY.POPUP.LINE_3', 'No registration, download, or card details needed')}
          </div>
          <div>
            {tr(
              'CHECKOUT.TRUSTLY.POPUP.LINE_4',
              'With no numbers to enter, Trustly is super-safe against scams and fraud. We respect your personal information and never use it for marketing.'
            )}
          </div>
          <div>
            {tr('CHECKOUT.TRUSTLY.POPUP.LEARN_MORE', 'Learn more at')}{' '}
            <a href='https://www.trustly.com/'>https://www.trustly.com/</a>
          </div>
        </div>
      </div>
    </div>
  )
}
